import styled from '@emotion/styled';

export const CardWrapper = styled.div`
  background: ${({ theme }) => theme.colors.neutrals.white};
  border-radius: ${({ theme }) => theme.borderRadius.extraLarge};
  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.05), 0 2px 5px rgba(0, 0, 0, 0.06);
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 4px 4px 16px;
  box-sizing: border-box;
`;

export const ImageArea = styled.div`
  position: relative;
`;

export const ImageWrapper = styled.div`
  height: 241px;
  overflow: hidden;
  border-radius: ${({ theme }) => theme.borderRadius.extraLarge};

  > div,
  > div > div {
    width: 100%;
    height: 100%;
  }

  > div > div > div:last-child {
    width: 100% !important;
    min-width: unset !important;
    height: 100% !important;
    min-height: unset !important;
    border: none;
    border-radius: 0;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const FavoriteOverlay = styled.div`
  position: absolute;
  z-index: 2;
  left: ${({ theme }) => theme.spacing(1.5)};
  top: ${({ theme }) => theme.spacing(1.5)};
`;

export const CompareOverlay = styled.div`
  position: absolute;
  z-index: 2;
  right: ${({ theme }) => theme.spacing(1.5)};
  top: ${({ theme }) => theme.spacing(1.5)};
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(1)};
  padding: 0 ${({ theme }) => theme.spacing(1.5)};
`;

export const IndicatorRow = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.spacing(0.5)};
`;
